import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useMaskedInput from "../../hooks/useMaskedInput";
import GeneralIcon from "../../assets";

export default function Step2Individual() {
  const location = useLocation();
  const navigate = useNavigate();

  const { selectedTitle } = location.state || {
    selectedTitle: "Pessoa Física",
  };

  const [docType, setDocType] = useState("CPF");
  const nameFantasy = useMaskedInput("Geppro Store", "name");
  const responsible = useMaskedInput("ROBERTO NUNES", "name");
  const documentMask = useMaskedInput("", "document", { docType });
  const emailMask = useMaskedInput("", "email");
  const [logoPreview, setLogoPreview] = useState("");

  const onLogoChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setLogoPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Persist step data
    // TODO: real model mapping
    try {
      const { saveStepData } = require("../../services/storeCreationService");
      saveStepData("step2", {
        type: selectedTitle,
        nameFantasy: nameFantasy.value,
        responsible: responsible.value,
        docType,
        document: documentMask.value,
        email: emailMask.value,
        logo: logoPreview,
      });
    } catch {}
    navigate("/create-store/step3", {
      state: {
        personData: { docType, selectedTitle },
      },
    });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white px-4">
      <div className="w-full max-w-lg space-y-6">
        <div className="flex items-center">
          <button onClick={handleBack} className="text-gray-600 mr-2">&larr;</button>
          <span className="text-sm text-gray-600">Criar loja</span>
        </div>
        <h2 className="text-2xl font-bold text-purple-600 text-center">
          Porte da Empresa: {selectedTitle}
        </h2>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Logo</label>
          <div className="grid grid-cols-[96px_1fr] gap-4 items-center">
            <div className="w-24 h-24 bg-purple-50 border border-purple-200 rounded-xl flex items-center justify-center overflow-hidden">
              {logoPreview ? (
                <img src={logoPreview} alt="Logo selecionada" className="w-full h-full object-cover" />
              ) : (
                <GeneralIcon iconName="loja" alt="loja" className="w-8 h-8 text-purple-600" />
              )}
            </div>
            <div className="h-28 border-2 border-dashed border-purple-400 rounded-xl flex items-center justify-center text-purple-600 relative">
              <div className="flex items-center gap-2 pointer-events-none">
                <GeneralIcon iconName="camera" alt="camera" className="w-5 h-5" />
                <span>Alterar a imagem</span>
              </div>
              <input type="file" accept="image/*" className="absolute inset-0 opacity-0 cursor-pointer" onChange={onLogoChange} />
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Nome fantasia<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-purple-500 focus:border-purple-500"
              placeholder="Geppro Store"
              value={nameFantasy.value}
              onChange={nameFantasy.onChange}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Responsável legal<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-purple-500 focus:border-purple-500"
              placeholder="ROBERTO NUNES"
              value={responsible.value}
              onChange={responsible.onChange}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Identificação para empresa<span className="text-red-500">*</span>
            </label>
            <div className="flex">
              <select
                value={docType}
                onChange={(e) => setDocType(e.target.value)}
                className="w-1/3 border border-gray-300 rounded-l-lg px-3 py-2 bg-white text-gray-700 focus:ring-purple-500 focus:border-purple-500 outline-none"
              >
                <option value="CPF">CPF</option>
                <option value="CNPJ">CNPJ</option>
              </select>
              <input
                type="text"
                value={documentMask.value}
                onChange={documentMask.onChange}
                className="mt-0 w-2/3 border border-l-0 border-gray-300 rounded-r-lg px-3 py-2 focus:ring-purple-500 focus:border-purple-500"
                placeholder={
                  docType === "CPF" ? "123.456.789-01" : "00.000.000/0000-00"
                }
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Email comercial<span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-purple-500 focus:border-purple-500"
              placeholder="joaosilva@exemplo.com"
              value={emailMask.value}
              onChange={emailMask.onChange}
            />
          </div>

          <button
            type="submit"
            disabled={!nameFantasy.value || !responsible.value || !emailMask.value || !documentMask.value}
            className={`w-full py-3 rounded-lg font-semibold transition ${nameFantasy.value && responsible.value && emailMask.value && documentMask.value ? 'bg-purple-600 text-white hover:bg-purple-700' : 'bg-purple-200 text-white cursor-not-allowed'}`}
          >
            Continuar
          </button>
        </form>
      </div>
    </div>
  );
}
